<template>
  <v-container class="pa-0 ma-0">
    <v-expansion-panel :disabled="disabled"
                       v-for="item in appointments"
                       :key="item.Id">
      <slot name="header">
        <v-expansion-panel-header v-slot="{ }"
                                  class="pt-0 pb-0 pl-1">
          <v-list class="pt-0 pb-0 pl-0"
                  style="min-width: 100px">
            <v-list-item>
              <v-list-item-icon class="ml-1 mr-5 mt-5">
                <v-icon size="20"
                        :color="progressColor(item)">mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{participantsHeader(item.Participants)}}
                  <v-spacer />
                  <span :class="progressColor(item) + '--text'">
                    {{(inProgress(item) === 0) ? $t('servicesystem.common_objects.appointment.in_progress') : fromNow(item.StartTime)}}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-header>
      </slot>
      <v-expansion-panel-content>
        <v-divider />
        <v-list>
          <edit-li :label="$t('servicesystem.common_objects.appointment.date')"
                   :value="toDateString(item.AppointmentDate)">
          </edit-li>
          <edit-li :label="$t('servicesystem.common_objects.appointment.start')"
                   :value="i18nFormatTime(item.StartTime)">
          </edit-li>
          <edit-li :label="$t('servicesystem.common_objects.appointment.end')"
                   :value="i18nFormatTime(item.EndTime)">
          </edit-li>
          <user-list-list-item :label="$t('servicesystem.common_objects.appointment.participants')"
                               :value="item.Participants">
          </user-list-list-item>
        </v-list>
        <v-btn @click="viewMore(item)"
               class="linkStyleButton">
          {{$t('servicesystem.common_objects.document.open_in_new_tab')}}
          <v-icon size="13"
                  class="pl-2">mdi-open-in-new</v-icon>
        </v-btn>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>


<script>
import EditLi from "@/components/Inputs/EditableListItem.vue";
import moment from "moment";
import UserListListItem from "../SingleUse/UserListListItem.vue";

export default {
  components: { EditLi, UserListListItem },
  props: ["appointments"],
  name: "AppointmentsPreview",

  data: () => ({
    disabled: false,
  }),

  mounted() {},

  methods: {
    viewMore(item) {
      let routeData = this.$router.resolve({
        name: "ViewJobPlanning",
        params: { filter: 'my', jobId: item.JobId, appointmentId: item.Id },
      });
      window.open(routeData.href, "_blank");
    },

    toDateString(dt) {
      return moment(dt).format("LL");
    },

    toTimeString(dt) {
      return moment(dt).format("LT");
    },

    participantsHeader(list) {
      if (list.length > 1) {
        return list[0].User.Name + " + " + (list.length - 1);
      } else if (list.length > 0) {
        return list[0].User.Name;
      } else {
        return "";
      }
    },
  },

  computed: {},

  watch: {},
};
</script>